<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      title="收费项目"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <div style="height: 70vh;">
        <el-button @click="$emit('chargeitemAll')">确定</el-button>
        <el-button @click="tup">关闭</el-button>
        <el-select v-model="chargeitem_id" clearable placeholder="账龄费项" @change="toggleSelection">
            <el-option
              v-for="(item,index) in chargeitem"
              :key="index"
              :label="item.number"
              :value="item.chargeitem_id">
            </el-option>
        </el-select>
        <div style="margin-top: 20px;overflow-y: auto;height: 60vh;">
          <el-table ref="multipleTable" border :data="data" height="60vh" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="sort" label="序号" width="120"></el-table-column>
              <el-table-column prop="label" label="收费项目" width="280"></el-table-column>
            </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
      data () {
        return {
          loading:false,
          dialogVisible:false,
          data: [],
          chargeitem:[],
          chargeitem_id:'',
          multipleSelection:[],
          defaultProps: {
            children: 'children',
            label: 'label'
          }
        }
      },
      mounted(){

      },
      //事件
      methods: {
        toggleSelection(rows) {
            this.$refs.multipleTable.clearSelection();
            if (rows) {
              this.data.forEach(row => {
                rows.forEach(rews=>{
                  if(row.id== rews.id){
                    this.$refs.multipleTable.toggleRowSelection(row);
                  }
                })
              });
            }
        },
        //返回数据
        getInvo(data){
          // console.log(data)
          this.dialogVisible = true;
          if(data.chargeitemID == ''){
            this.selects(data);
          }
        },
        // 查询
        selects(data){
            this.chargeitem_id = '';
            this.$myhttp.post('admin/common/chargritem',data,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.data = backdata.data.data;
                this.chargeitem = backdata.data.chargeitem;
            },err=>{
              this.$Message.error('请求异常!');
            });
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        getReturn(){
          this.dialogVisible = false;
          return this.multipleSelection;
        },
        tup(){
           this.dialogVisible = false;
        },
        handleClose(done) {
          done();
        },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/common/Chargeitem.vue